/* eslint-disable class-methods-use-this */
import { IAdvertisedCoursesRes } from "../models/advertisedcourse.model";
import {
  IAnnouncementRes,
  IAvailableCoureResponse,
  IAvailableCourse,
  ICreateAnnouncement,
} from "../models/trainee-course.model";
import getService from "./getService";
import postService from "./postService";

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || "http://20.126.75.78/naptin/api/v1/";

const GETANNOUNCEMENT = "announcements/";
const CREATEANNOUNCEMENT = "announcements";
const GETANNOUNCEMENTSUBSCRIBERS = "announcements/";
const GETDISCUSSIONTOPICS = "courses/";
const GETAVAILABLECOURSES = "available-courses";
const GETCOURSETYPES = "course-types";
const GETADVERTISEDCOURSES = "courses/advertise/all";
const JOINTOPICDISCUSSION = `discussion-topics/`;
const DISCUSSIONREPLY = "discussions/";
const CREATETERM = "course-terms";
const CREATESESSION = "course-sessions";

class CourseServices {
  async getCourse(uuid: string) {
    const response = await getService.get(`${CONFIG_API_URL}courses/${uuid}`);
    return response.data;
  }

  async getAnnouncements(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETANNOUNCEMENT}${uuid}`
    );

    return response;
  }
  async getAnnouncementSubscribers(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETANNOUNCEMENTSUBSCRIBERS}${uuid}/subscribers`
    );

    return response;
  }
  async createAnnouncement(data: ICreateAnnouncement) {
    const response = await postService.post(
      `${CONFIG_API_URL}${CREATEANNOUNCEMENT}`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }

  async createSession(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${CREATESESSION}`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }

  async createTerm(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${CREATETERM}`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }

  async getDiscussionTopics(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETDISCUSSIONTOPICS}${uuid}/discussion-topics`
    );

    return response;
  }

  async createDiscussionTopics(data: ICreateAnnouncement, uuid: string) {
    const response = await postService.post(
      `${CONFIG_API_URL}${GETDISCUSSIONTOPICS}${uuid}/discussion-topics`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }

  async getAvailableCourses() {
    const response: any = await getService.get(
      `${CONFIG_API_URL}${GETAVAILABLECOURSES}`
    );

    const res: IAvailableCoureResponse = response.data;
    return res.data;
  }

  async getTopicsForCourse(uuid: any) {
    const response: any = await getService.get(
      `${CONFIG_API_URL}${GETDISCUSSIONTOPICS}${uuid}/topics`
    );
    return response.data;
  }

  async getAttendanceList(uuid: string) {
    const response: any = await getService.get(
      `${CONFIG_API_URL}course-availability/${uuid}/attendances`
    );

    const res: IAvailableCourse = response.data;

    return res;
  }

  async getanAvailableCourse(uuid: string | number) {
    const response: any = await getService.get(
      `${CONFIG_API_URL}${GETAVAILABLECOURSES}/${uuid}`
    );

    const res: IAvailableCourse | any = response.data.data;

    return res;
  }

  async getAdvertisedCourses() {
    const response: any = await getService.get(
      `${CONFIG_API_URL}trainees/fetch-advertised-by-user`
    );

    const res: IAdvertisedCoursesRes = response.data;
    return res.data;
  }

  async joinDiscussionTopic(data: string, uuid: string) {
    const response = await postService.post(
      `${CONFIG_API_URL}${JOINTOPICDISCUSSION}${uuid}/join`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }

  async replyDiscussion(data: any, uuid: string) {
    const response = await postService.post(
      `${CONFIG_API_URL}${DISCUSSIONREPLY}${uuid}/replies`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }

  async traineeChoosePosting(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}courses/trainee-choose-posting-centres`,
      data
    );
    return response.data;
  }

  async getTraineeResult(uuid: string, enrollment_id: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}users/${uuid}/courses-enrolled/${enrollment_id}/result`
    );
    return response.data;
  }

  async downloadTraineeResult(uuid: any, enrollment_id: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}users/${uuid}/courses-enrolled/${enrollment_id}/result-download`
    );
    return response.data;
  }
}
export default new CourseServices();
